<template>
    <v-dialog v-model="dialog" persistent :width="width">
        <v-card>
            <v-card-title class="text-h5">{{ title }}</v-card-title>
            <v-card-text v-if="message">{{ message }}</v-card-text>
            <v-card-text v-else-if="error" class="red--text text--lighten-2">{{ error }}</v-card-text>
            <v-card-text v-if="!error">
                <v-progress-linear indeterminate color="primary" />
            </v-card-text>
            <v-card-actions v-if="error">
                <v-spacer />
                <v-btn color="error" @click="close">Cerrar</v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss"></style>

<script lang="ts">
import { EventBus } from "@/components/EventBus";
import { OpenProgressRequest, UpdateProgressRequest, DataClient } from "@/services/DataClient";
import { Utilities } from "@/services/Utilities";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
    dialog = false;

    title = "";
    message = "";
    error = "";
    width = "800";

    mounted() {
        EventBus.$on(DataClient.Dialogs.OpenProgressDialogEvent, this.handleOpenEvent);
        EventBus.$on(DataClient.Dialogs.CloseProgressDialogEvent, this.handleCloseEvent);
        EventBus.$on(DataClient.Dialogs.UpdateProgressDialogEvent, this.handleUpdateEvent);
    }

    beforeDestroy() {
        EventBus.$off(DataClient.Dialogs.OpenProgressDialogEvent, this.handleOpenEvent);
        EventBus.$off(DataClient.Dialogs.CloseProgressDialogEvent, this.handleCloseEvent);
        EventBus.$off(DataClient.Dialogs.UpdateProgressDialogEvent, this.handleUpdateEvent);
    }

    reset() {
        this.dialog = false;
    }

    async handleOpenEvent(event: OpenProgressRequest) {
        this.title = event.title;
        this.message = "";
        this.error = "";

        this.dialog = true;
    }

    async handleCloseEvent() {
        this.reset();
    }

    async handleUpdateEvent(event: UpdateProgressRequest) {
        this.message = event.message || "";
        this.error = event.error || "";
    }

    close() {
        this.reset();
    }
}
</script>
